<template>
  <div>
    <v-container class="global-margin">
      <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <h2 class="display-2 w-100 pb-5">Kontakti</h2>
          <p
            class="mb-0"
          >Ovdje možete pronaći popis kontakata svih škola. Na popisu se nalaze kontakti škola koje su do sada poslale podatke.</p>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-expansion-panels focusable flat hover v-for="(item, i) in contacts" :key="i">
            <v-expansion-panel class="mb-2">
              <v-expansion-panel-header
                class="blue-text font-weight-medium py-7 text-uppercase"
              >{{ item.title }}</v-expansion-panel-header>
              <v-expansion-panel-content class="py-5 pb-0">
                <v-expansion-panels focusable flat hover v-for="(city, j) in item.cities" :key="j">
                  <v-expansion-panel style class="mb-2">
                    <v-expansion-panel-header
                      class="blue-text font-weight-medium py-7 text-uppercase"
                    >{{city.title}}</v-expansion-panel-header>
                    <v-expansion-panel-content class="py-5 pb-0">
                      <div v-for="(school, k) in city.schools" :key="k">
                        <v-row>
                          <v-col cols="1">
                            <v-icon>fas fa-angle-double-right</v-icon>
                          </v-col>
                          <v-col cols="11">
                            <p class="mb-0 pb-0">{{school.name}}</p>
                            <span class="grey--text">
                                Kontakt mail:
                              <a
                                class="mail-link"
                                :href="'mailto:'+ school.contact_email"
                              >{{school.contact_email}}</a>
                            </span><br>
                            <span class="grey--text">
                                Informatička podrška:
                              <a
                                class="mail-link"
                                :href="'mailto:'+ school.contact_it"
                              >{{school.contact_it}}</a>
                            </span>
                          </v-col>
                        </v-row>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8">
          <v-img :src="require('@/assets/img/podrska.png')"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contacts: [],
      breadcrumbs: [
        {
          text: 'Naslovnica',
          disabled: false,
          to: '/'
        },
        {
          text: 'Kontakt',
          disabled: true,
        },
      ],
    };
  },
  mounted() {
    this.getContacts();
  },
  methods: {
    getContacts: function() {
      axios
        .get("https://skole.sum.ba/admin/api/ostalo/skola/po_zupanijama")
        .then(response => {
          this.contacts = response.data;
        //   console.log(this.contacts);
        })
        .catch(error => console.log(error.message));
    }
  }
};
</script>

<style>
.mail-link {
  text-decoration: none;
  color: #9e9e9e !important;
}

.mail-link:hover {
  color: red !important;
}
</style>
